import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Mumbaitobanglorecab() {



  const cardData = {
    keyword: " Mumbai to Bangalore Cab ",


"headingDescription": "Royal Route Cab offers reliable and comfortable Mumbai to Bangalore cab services, ensuring a safe, smooth, and stress-free long-distance journey for families, business travelers, and group passengers. Bangalore is India’s leading IT hub, known for its pleasant climate, gardens, technology parks, and vibrant city life, making it one of the most important intercity routes from Mumbai. Our professional drivers and well-maintained vehicles ensure a comfortable travel experience throughout the journey. The Mumbai to Bangalore route covers approximately 980 to 1,050 km via NH48 and takes around 16 to 20 hours depending on traffic, road conditions, and stoppages. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and Tempo Travellers suitable for all types of travelers. With easy online booking and 24/7 customer support, Royal Route Cab is your trusted partner for Mumbai to Bangalore travel.",

"topPlaces": [
  {
    "title": "Lalbagh Botanical Garden",
    "description": "Lalbagh Botanical Garden is one of Bangalore’s most iconic green spaces, home to rare plant species, centuries-old trees, and the famous glasshouse inspired by London’s Crystal Palace. It is especially popular during flower shows and offers a peaceful escape in the middle of the city with walking paths, lakeside views, and photography spots."
  },
  {
    "title": "Cubbon Park",
    "description": "Cubbon Park is a large urban park located in the heart of Bangalore, known for its lush greenery, walking trails, and colonial-era architecture nearby. It is a favorite spot for morning walkers, families, and nature lovers seeking calm surroundings within the bustling city."
  },
  {
    "title": "Bangalore Palace",
    "description": "Bangalore Palace is a stunning royal residence inspired by Tudor-style architecture, featuring wooden interiors, stained glass windows, and vintage furniture. Visitors can explore its grand halls and learn about the royal history of the Wodeyar dynasty."
  },
  {
    "title": "ISKCON Temple Bangalore",
    "description": "ISKCON Temple Bangalore is a major spiritual and cultural landmark dedicated to Lord Krishna. Known for its grand architecture, devotional chants, and peaceful environment, it attracts devotees and tourists from across the world."
  },
  {
    "title": "Commercial Street",
    "description": "Commercial Street is one of Bangalore’s most popular shopping destinations, offering clothing, accessories, street food, and budget-friendly shopping options. It is always bustling with activity and is ideal for tourists looking for a lively market experience."
  },
  {
    "title": "MG Road & Brigade Road",
    "description": "MG Road and Brigade Road are the central commercial and entertainment hubs of Bangalore, filled with cafes, pubs, restaurants, and shopping outlets. These roads represent the modern lifestyle and nightlife culture of the city."
  },
  {
    "title": "Bannerghatta National Park",
    "description": "Bannerghatta National Park is a wildlife sanctuary near Bangalore offering safaris to see lions, tigers, elephants, and other animals. It also includes a butterfly park and zoo, making it a popular family-friendly attraction."
  },
  {
    "title": "Nandi Hills",
    "description": "Nandi Hills is a famous hill station located near Bangalore, known for its breathtaking sunrise views, misty landscapes, and historical fort ruins. It is a popular weekend getaway for trekking, photography, and nature relaxation."
  },
  {
    "title": "Ulsoor Lake",
    "description": "Ulsoor Lake is one of the largest lakes in Bangalore, offering boating activities and peaceful surroundings. It is a calm escape from city traffic and a great place for evening walks and photography."
  },
  {
    "title": "Vidhana Soudha",
    "description": "Vidhana Soudha is a monumental government building in Bangalore showcasing impressive neo-Dravidian architecture. It is one of the city’s most iconic landmarks and represents Karnataka’s political importance."
  }
],






services: [
  {
    name: "Mumbai to Bangalore Cab",
    description: "Mumbai to Bangalore cab service offers a comfortable and long-distance travel solution connecting two major metro cities. The route covers scenic highways, industrial hubs, and green landscapes, making the journey enjoyable. Ideal for business travelers, families, and relocations, this service ensures safe and timely travel. Professional drivers experienced in long routes enhance safety. Multiple vehicle options are available. It guarantees a smooth and hassle-free journey."
  },
  {
    name: "Mumbai to Bangalore Taxi",
    description: "Mumbai to Bangalore taxi provides convenient and private transportation with door-to-door pickup and drop. This service is perfect for travelers seeking a comfortable long-distance ride. Vehicles are well-maintained and driven by experienced chauffeurs. Suitable for business trips and family travel. It ensures a smooth and stress-free journey."
  },
  {
    name: "Mumbai to Bangalore Cab Service",
    description: "Mumbai to Bangalore cab service is designed for long-distance intercity travel with a focus on comfort and safety. The route ensures smooth highway connectivity across states. This service is ideal for corporate travel, relocation, and extended road trips. Vehicles are maintained for high performance. It ensures a dependable journey."
  },
  {
    name: "Mumbai to Bangalore Taxi Service",
    description: "Mumbai to Bangalore taxi service offers reliable transportation for long-distance travel. Clean vehicles and trained drivers ensure a comfortable ride. Flexible scheduling allows easy travel planning. Door-to-door service enhances convenience. It guarantees a hassle-free experience."
  },
  {
    name: "Cab from Mumbai to Bangalore",
    description: "Cab from Mumbai to Bangalore provides a personalized travel experience with flexible stops along the route. Travelers can enjoy a comfortable and private journey across multiple states. This service is ideal for families and small groups. Professional drivers ensure safe travel. It offers a relaxed road trip experience."
  },
  {
    name: "Taxi from Mumbai to Bangalore",
    description: "Taxi from Mumbai to Bangalore offers a convenient and efficient way to travel between the two cities. With experienced drivers and comfortable vehicles, the journey is smooth and enjoyable. Door-to-door pickup adds convenience. Suitable for business and leisure travel. It ensures a reliable journey."
  },
  {
    name: "Mumbai to Bangalore Cab Booking",
    description: "Mumbai to Bangalore cab booking allows travelers to reserve their ride easily with flexible options. Customers can choose vehicle type, pickup location, and timing. Instant confirmation and transparent pricing ensure a hassle-free process. It simplifies travel planning."
  },
  {
    name: "Mumbai to Bangalore Taxi Booking Online",
    description: "Mumbai to Bangalore taxi booking online provides a quick and convenient way to plan your journey. Customers can compare vehicle options and pricing easily. Secure payment and instant confirmation enhance convenience. It ensures availability during peak travel times."
  },
  {
    name: "Mumbai to Bangalore Cab Price",
    description: "Mumbai to Bangalore cab price varies based on vehicle type, travel duration, and trip type. Transparent pricing ensures no hidden charges. Budget-friendly sedan options and premium SUVs are available. It helps travelers plan their trip efficiently. It ensures value for money."
  },
  {
    name: "Mumbai to Bangalore Taxi Fare",
    description: "Mumbai to Bangalore taxi fare is designed to be competitive and flexible for long-distance travel. Fare depends on car type and travel plan. Customers receive clear pricing details before booking. Multiple options suit different budgets. It ensures cost-effective travel."
  },
  {
    name: "Mumbai to Bangalore One Way Cab",
    description: "Mumbai to Bangalore one way cab is a cost-effective option for travelers needing a single-side drop across states. This service eliminates return charges and offers flexible travel timings. Ideal for relocation and business trips. Comfortable vehicles ensure a smooth ride. It is perfect for budget travel."
  },
  {
    name: "Mumbai to Bangalore Round Trip Taxi",
    description: "Mumbai to Bangalore round trip taxi is ideal for travelers planning return travel after their trip. This package includes pickup, drop, waiting time, and return journey. Flexible schedules make it convenient. Suitable for corporate and family travel. It ensures comfort and efficiency."
  },
  {
    name: "Mumbai to Bangalore Innova Cab",
    description: "Mumbai to Bangalore Innova cab is perfect for families and groups seeking spacious and comfortable travel for long journeys. The vehicle offers ample seating and luggage space. Ideal for multi-day travel. Professional drivers ensure safety. It provides a premium travel experience."
  },
  {
    name: "Mumbai to Bangalore Ertiga Cab",
    description: "Mumbai to Bangalore Ertiga cab is suitable for small groups and families looking for an affordable yet spacious ride. This vehicle offers comfortable seating and good mileage. It is ideal for budget-friendly travel. Drivers ensure smooth journeys. It ensures a pleasant experience."
  },
  {
    name: "Mumbai to Bangalore Sedan Cab",
    description: "Mumbai to Bangalore sedan cab is ideal for couples and small families seeking economical travel. Sedans offer smooth driving and comfort for long-distance trips. This option is widely preferred for its affordability. Professional drivers ensure safe travel. It is perfect for a relaxed journey."
  },
  {
    name: "Mumbai to Bangalore SUV Taxi",
    description: "Mumbai to Bangalore SUV taxi provides extra space and comfort for group travel across long distances. SUVs offer better stability and performance on highways. This option is ideal for families and corporate groups. Drivers ensure safe and reliable travel. It delivers a comfortable experience."
  },
  {
    name: "Cheap Mumbai to Bangalore Cab",
    description: "Cheap Mumbai to Bangalore cab offers budget-friendly travel options without compromising comfort and safety. This service is ideal for cost-conscious travelers. Economical sedan options help reduce travel costs. Transparent pricing ensures no hidden charges. It is perfect for affordable trips."
  },
  {
    name: "Best Mumbai to Bangalore Taxi Service",
    description: "Best Mumbai to Bangalore taxi service ensures a premium travel experience with top-quality vehicles and professional drivers. This service focuses on punctuality, safety, and customer satisfaction. Multiple vehicle options are available for different needs. Transparent pricing builds trust. It guarantees a reliable and comfortable journey."
  }
],

tableData: [
  ["Mumbai to Bangalore Cab", "Mumbai to Bangalore Taxi"],
  ["Mumbai to Bangalore Cab Service", "Mumbai to Bangalore Taxi Service"],
  ["Cab from Mumbai to Bangalore", "Taxi from Mumbai to Bangalore"],
  ["Mumbai to Bangalore Cab Booking", "Mumbai to Bangalore Taxi Booking Online"],
  ["Mumbai to Bangalore Cab Price", "Mumbai to Bangalore Taxi Fare"],
  ["Mumbai to Bangalore One Way Cab", "Mumbai to Bangalore Round Trip Taxi"],
  ["Mumbai to Bangalore Innova Cab", "Mumbai to Bangalore Ertiga Cab"],
  ["Mumbai to Bangalore Sedan Cab", "Mumbai to Bangalore SUV Taxi"],
  ["Cheap Mumbai to Bangalore Cab", "Best Mumbai to Bangalore Taxi Service"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Mumbai to Bangalore Travel",
    WhyChoosedescription: "Royal Route Cabs offers a smooth and comfortable Mumbai to Bangalore cab service, ideal for long-distance business trips, family travel, and intercity journeys."
  },
  {
    WhyChooseheading: "Experienced Long-Distance Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in handling long highway routes like Mumbai to Bangalore, ensuring safe driving, proper navigation, and timely arrival."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear and upfront pricing including tolls, driver allowance, and all travel costs with no hidden charges."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Mumbai to Bangalore cab service operates 24/7, allowing flexible departure anytime as per your schedule."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well-maintained, and regularly cleaned to ensure a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way cab service, round-trip bookings, or multi-day travel options for Bangalore trips."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for individuals and group travel."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by travelers for Mumbai to Bangalore cab bookings due to reliable service, professional drivers, and smooth travel experience."
  }
]

};

const faqData = [
  { question: "Do you provide Mumbai to Bangalore cab service?", answer: "Yes, Royal Route Cabs offers reliable cab services from Mumbai to Bangalore for both one-way and round trips." },
  { question: "What is the distance between Mumbai and Bangalore?", answer: "The distance is approximately 980 to 1050 km and takes around 16 to 20 hours depending on route and traffic." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai to Bangalore cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable long-distance travel." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we offer pickup from home, hotel, and airport anywhere in Mumbai." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for long-distance trips like Mumbai to Bangalore." },
  { question: "Do you provide multi-day travel support?", answer: "Yes, we offer flexible multi-day travel plans with driver support for long journeys." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Arjun Reddy",
    feedback: "The long journey from Mumbai to Bangalore with Royal Route Cabs was handled very professionally. The ride was comfortable and the driver ensured safe driving throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Iyer",
    feedback: "Excellent experience for our Mumbai to Bangalore trip. The cab was clean, well-maintained, and the journey felt smooth and stress-free with Royal Route Cabs.",
    rating: 5
  }
];


















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Bangalore Cab",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-to-bangalore-cab.jpg", // replace if needed
  "description": "Book Mumbai to Bangalore cab with Royal Route Cabs for a safe, comfortable, and long-distance travel experience. Choose from sedan, SUV, Innova, and luxury cars for one-way and round-trip taxi services with 24x7 availability and professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "12000", // adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-to-bangalore-cab"
  }
};






  return (
    <div>
<Helmet>
  <title>Mumbai to Bangalore Cab | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai to Bangalore cab at best price with Royal Route Cabs. One-way & round-trip taxi service with sedan, SUV, Innova & luxury cars. Safe, reliable & 24x7 available."
  />

  <meta
    name="keywords"
    content="mumbai to bangalore cab, mumbai to bangalore taxi, mumbai to bangalore cab service, mumbai to bangalore taxi service, cab from mumbai to bangalore, taxi from mumbai to bangalore, mumbai to bangalore cab booking, mumbai to bangalore taxi booking online, mumbai to bangalore cab price, mumbai to bangalore taxi fare, mumbai to bangalore one way cab, mumbai to bangalore round trip taxi, mumbai to bangalore innova cab, mumbai to bangalore ertiga cab, mumbai to bangalore sedan cab, mumbai to bangalore suv taxi, cheap mumbai to bangalore cab, best mumbai to bangalore taxi service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/95.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitobanglorecab;